import { Banknote, Landmark } from "lucide-react";

const Chip = ({ children, label }) => (
  <span
    aria-label={label}
    data-testid={`payment-chip-${label}`}
    className="inline-flex h-7 select-none items-center justify-center rounded-[6px] bg-white px-2 leading-none shadow-sm ring-1 ring-black/5"
  >
    {children}
  </span>
);

const LOGOS = [
  { label: "upi", src: "/pay/upi.svg", alt: "UPI", h: "h-4" },
  { label: "visa", src: "/pay/visa.svg", alt: "Visa", h: "h-3.5" },
  { label: "mastercard", src: "/pay/mastercard.svg", alt: "Mastercard", h: "h-5" },
  { label: "rupay", src: "/pay/rupay.svg", alt: "RuPay", h: "h-3.5" },
];

/**
 * India-first payment confidence cues using official brand SVG logos
 * (UPI, Visa, Mastercard, RuPay) plus Net Banking and an optional COD badge.
 */
export const PaymentBadges = ({ className = "", showCod = true }) => (
  <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="payment-badges">
    {LOGOS.map((l) => (
      <Chip key={l.label} label={l.label}>
        <img src={l.src} alt={l.alt} className={`${l.h} w-auto`} draggable="false" loading="lazy" />
      </Chip>
    ))}
    <Chip label="netbanking">
      <span className="inline-flex items-center gap-1 text-[12px] font-bold text-[#1F2937]">
        <Landmark size={13} /> Net Banking
      </span>
    </Chip>
    {showCod && (
      <span
        data-testid="payment-chip-cod"
        className="inline-flex h-7 select-none items-center gap-1.5 rounded-[6px] border border-[color:var(--acx-border)] bg-white/5 px-2.5 text-[12px] font-semibold text-white"
      >
        <Banknote size={14} className="text-[#34D399]" /> Cash on Delivery available
      </span>
    )}
  </div>
);

export default PaymentBadges;
